import propTypes from 'prop-types';
import React, { useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import { connect } from 'react-redux';
import { getCoupons } from '../../actions/coupon';
import CouponItem from './CouponItem';


const AllCoupons = ({
  auth,
  getCoupons,
  coupon: {coupons},
}) => {

  useEffect(() => {
    getCoupons();
  }, [getCoupons]);

  return (
    <div className='container'>
    <Row xs={1} md={3} className="g-4">
        {coupons.map(coupon => (
            <CouponItem key={coupon._id} coupon={coupon} />
        ))}
    </Row>
    </div>
  )
};

AllCoupons.propTypes = {
  getCoupons: propTypes.func.isRequired,
  coupon: propTypes.object.isRequired,
};

const mapStateToProps = state => ({
  coupon: state.coupon,
});

export default connect(mapStateToProps, { getCoupons })(AllCoupons);